if (!customElements.get('lookbook-icon')) {
  customElements.define(
    'lookbook-icon',
    class LookbookIcon extends HTMLElement {
      constructor() {
        super();

        this.selectors = {
          cardContainer: '.lookbook-card',
          cardProduct: '.lookbook-icon__card',
        };

        // Space kept between the card and the edges of the image.
        this.edgeGutter = 8;

        this.cardContainer = this.closest(this.selectors.cardContainer);
        this.cardProduct = this.querySelector(this.selectors.cardProduct);

        this.onMouseOver = this.init.bind(this);
        this.onClick = this.handleClick.bind(this);

        this.init();
        document.addEventListener('matchMobile', () => {
          this.init();
        });
        document.addEventListener('unmatchMobile', () => {
          this.init();
        });
        this.addEventListener('mouseover', this.onMouseOver);
        this.addEventListener('click', this.onClick);

        LookbookIcon.setupGlobalListeners();

        if (this.cardContainer && this.cardProduct && 'ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => {
            cancelAnimationFrame(this.resizeFrame);
            this.resizeFrame = requestAnimationFrame(() => this.init());
          });
          this.resizeObserver.observe(this.cardContainer);
        }
      }

      disconnectedCallback() {
        this.removeEventListener('mouseover', this.onMouseOver);
        this.removeEventListener('click', this.onClick);
        cancelAnimationFrame(this.resizeFrame);
        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        }
      }

      // Cards are opened by click only: the same pin toggles, another pin
      // replaces the open one, a click anywhere else closes it.
      handleClick(event) {
        // Clicks inside the card itself (product link, price) must go through.
        if (this.cardProduct && this.cardProduct.contains(event.target)) return;
        this.toggleCard(!this.classList.contains('is-active'));
      }

      toggleCard(open) {
        if (!open) {
          this.classList.remove('is-active');
          return;
        }

        LookbookIcon.closeAll(this);
        this.init();
        this.classList.add('is-active');
      }

      static closeAll(except) {
        document.querySelectorAll('lookbook-icon.is-active').forEach((icon) => {
          if (icon !== except) icon.classList.remove('is-active');
        });
      }

      static setupGlobalListeners() {
        if (LookbookIcon.globalListenersAdded) return;
        LookbookIcon.globalListenersAdded = true;

        document.addEventListener('click', (event) => {
          if (event.target instanceof Element && event.target.closest('lookbook-icon')) return;
          LookbookIcon.closeAll();
        });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') LookbookIcon.closeAll();
        });
      }

      init() {
        this.classes = '';
        if (this.cardProduct) {
          const containerRect = this.cardContainer.getBoundingClientRect();

          // Never let the card grow wider than the image it belongs to.
          this.style.setProperty(
            '--card-max-width',
            `${Math.max(containerRect.width - this.edgeGutter * 2, 0)}px`
          );

          this.cardContainerOffsetX = containerRect.left;
          this.cardContainerOffsetY = containerRect.top;

          this.offsetX = this.getBoundingClientRect().left - this.cardContainerOffsetX;
          this.offsetY = this.getBoundingClientRect().top - this.cardContainerOffsetY;

          this.width = this.clientWidth
          this.cardWidth = this.cardProduct.clientWidth;
          this.cardHeight = this.cardProduct.clientHeight;
          this.wrapperWidth = this.cardContainer.clientWidth
          this.wrapperHeight = this.cardContainer.clientHeight

          this.cardPosition = this.offsetY > this.cardHeight ? 'top' : 'bottom'

          if ((this.offsetX + this.width) > this.cardWidth) {
            this.cardPosition += '-left'
          } else if ((this.wrapperWidth - this.offsetX) > this.cardWidth) {
            this.cardPosition += '-right'
          }

          this.dataset.position = this.cardPosition;

          this.keepCardInsideContainer(containerRect);
        }

        if (Shopify.designMode) {
          this.addEventListener('shopify:block:select', () => {
            this.cardProduct.style.transition = 'none';
            this.classList.add('is-active');
          });

          this.addEventListener('shopify:block:deselect', () => {
            this.classList.remove('is-active');
          });
        }
      }

      // The anchored positions above are relative to the pin, so on narrow
      // screens a card can still stick out of the image and get clipped by the
      // viewport. Nudge it back horizontally until it fits.
      keepCardInsideContainer(containerRect) {
        const card = this.cardProduct;
        const transition = card.style.transition;

        // Measure the resting position, with no transition in flight.
        card.style.transition = 'none';
        card.style.translate = '';
        const cardRect = card.getBoundingClientRect();

        const minLeft = containerRect.left + this.edgeGutter;
        const maxRight = containerRect.right - this.edgeGutter;
        let shift = 0;

        if (cardRect.left < minLeft) {
          shift = minLeft - cardRect.left;
        } else if (cardRect.right > maxRight) {
          shift = maxRight - cardRect.right;
        }

        card.style.translate = shift ? `${Math.round(shift)}px` : '';
        card.getBoundingClientRect();
        card.style.transition = transition;
      }
    }
  );
}
